import { Injectable, inject } from '@angular/core';

import { EventDetailsColumnType, EventModel } from '@frontend/sports/betting-offer/feature/model';
import { MediaEventSource, MediaModuleContextPage } from '@frontend/sports/grid/media/feature/model';
import { TrackingVideoSource } from '@frontend/sports/tracking/feature';
import { Store } from '@ngrx/store';

import { MediaApiActions } from './actions';

@Injectable({
    providedIn: 'root',
})
export class MediaApiService {
    private store = inject(Store);

    togglePlaying(value: boolean): void {
        this.store.dispatch(MediaApiActions.togglePlaying({ value }));
    }

    setMediaWidgetContext(mediaModuleContext: MediaModuleContextPage, eventId: string | null): void {
        this.store.dispatch(
            MediaApiActions.setMediaWidgetContext({
                payload: {
                    page: mediaModuleContext,
                    eventId,
                },
            }),
        );
    }

    setEvent(event: EventModel, source: MediaEventSource, tab: EventDetailsColumnType | null, trackingVideoSource: TrackingVideoSource): void {
        this.store.dispatch(
            MediaApiActions.setEvent({
                payload: {
                    event,
                    source,
                    tab,
                    trackingVideoSource,
                },
            }),
        );
    }

    setEventId(eventId: string, source: MediaEventSource, tab: EventDetailsColumnType | null, trackingVideoSource: TrackingVideoSource): void {
        this.store.dispatch(
            MediaApiActions.setEventId({
                payload: {
                    eventId,
                    source,
                    tab,
                    trackingVideoSource,
                },
            }),
        );
    }
}
